import { Component, OnInit } from '@angular/core';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { Router, NavigationEnd } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CategoryService } from 'src/app/_service/category.service';
import { WatchHistoryService } from 'src/app/_service/watch-history.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';

@Component({
  selector: 'app-tqr',
  templateUrl: './tqr.component.html',
  styleUrls: ['./tqr.component.css']
})
export class TqrComponent implements OnInit {
  isOffline: boolean = false;
  isLoggedIn:boolean = false;
  isDownloadRoute:boolean = false;
  excludeOfflineRoutes: string[] = ['/downloads', '/shaka-player', '/video'];
  isMobile:boolean;
  isDetailsPage:boolean = false;
  channelData:any[] = [];

  countrys:any[] = [];
  
  constructor(
    private networkStatusService: AuthenticateserviceService, 
    private router: Router,
    private breakerPointObserver: BreakpointObserver,
    private categ: CategoryService,
    private watchHistoryService: WatchHistoryService,
    private device: DeviceService
    ) {
    this.isLoggedIn = this.networkStatusService.isAuthenticated();
  }

  ngOnInit() {
    this.breakerPointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.networkStatusService.isOnline.subscribe(status => {
      this.isOffline = !status;
    });
    this.watchHistoryService.loadUserWatchHistory();
    this.getChannelsData();
    this.checkCurrentRoute();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.checkCurrentRoute();
      }
    });
  }

  getChannelsData(){
    this.categ.getChannelInfoByUserId().subscribe((result)=>{
      this.channelData = result;
    },(error)=>{
    });
  }

  checkCurrentRoute() {
    const currentRoute = this.router.url;
    this.excludeOfflineRoutes = ['/downloads', '/shaka-player', '/video'];
    this.isDownloadRoute = this.excludeOfflineRoutes.some(route => currentRoute.includes(route));
    this.isDetailsPage = this.device.isTV() && (currentRoute.includes('/movies/') || currentRoute.includes('/shows/'));
  }
}
